<template>

  <div>
    <b-card class="modal-validJustif">
      <p>Justification pour la ligne d'anomalie : {{idAnomalie}} </p>
      <p>Veuillez renseigner le type de la justification:</p>
      <label for="justification">justification</label>
      <input type="radio" v-model="type" value="justification" class="m-1" @click ="showJustification = true">
      <label for="correction">correction</label>
      <input type="radio" v-model= "type" value="correction" class="m-1" @click ="showJustification = false">

      <div id="justif" v-show="showJustification">
        <b-form-group id="input-group-5" label="Si cette anomalie possède une justification veuillez la saisir ci-dessous:"
        label-for="textarea-large">
          <b-form-textarea id="textarea-large"  type="textarea" rows="4" v-model="justificationText"></b-form-textarea>
        </b-form-group>
      </div>

      <div>
        <b-button pill @click="insertJustification" class="nav-link3 m-2">Valider</b-button>
        <b-button pill @click="$emit('close')" class="nav-link2 m-2">Annuler</b-button>
      </div>
    </b-card>
  </div>

</template>

<script>
import useValidJustif from "@/composition/Rapports/validJustifs";
export default {
  name:"ValidJustif",

  props: {
    idAnomalie:{
      type:Number

    }
  },
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  setup(props, { emit }) {
    return useValidJustif(props,{emit})
  },
};
</script>

<style>

.modal-validJustif{
  background-color: #17a2b8;
}

</style>